import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map } from 'rxjs';
import { nextActions } from '@app/store/next';
import { courseActions } from '../actions/course.actions';

@Injectable({
    providedIn: 'root',
})
export class NextCourseBridge {
    private readonly actions = inject(Actions);

    onNextFetchGetCourse$ = createEffect(() => {
        return this.actions.pipe(
            ofType(nextActions.getNextContentSuccess),
            map(({ payload }) => payload.courseId),
            filter((courseId) => courseId !== null),
            map((courseId) => courseActions.getCourse({ id: courseId })),
        );
    });
}
